import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.services';
import { ToastrService } from 'ngx-toastr';
import { environment } from 'src/environments/environment';
import { ProviderSearchModel } from '../model/provider-search.model';

@Injectable()
export class RollinService extends BaseService {

  constructor(private http: HttpClient,
    public toastr: ToastrService) {
    super(toastr);
  }

  getTransferOptions(): Observable<any> {
    return this.http.get(environment.apiUrl + `/rollin/transfer-options/list`, { headers: this.headers() });
  }

  providerSearch(obj : ProviderSearchModel): Observable<any> {
    return this.http.post<ProviderSearchModel>(environment.apiUrl + `/rollin/provider-search`,obj, { headers: this.headers() });
  }
}
